
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import  LeftSection  from "./layout/LeftSection";
import Chart from './chart/Chart';
const  Market = (props) => {
  const [activeproductchart, setActiveproductchart] = useState(16); 
  const handleClickActiveProduct = (id='') =>
  {
    setActiveproductchart(id);
  }
  return (
    <>
      <section className="mt-4 mb-4 ivo-main-index">
        <div className="container-fluid d-flex">
                <div className="w-50 h-80 m-auto text-center p-4">
                    <h5>We are currently working on this page </h5>
                    <p>...</p>
                </div>
        </div>

    </section>
    </>

  );
}

export default Market;
